var map = {
	"./modules/2c2p-module/twoC2P-module.module": [
		"./src/app/modules/2c2p-module/twoC2P-module.module.ts",
		"default~modules-2c2p-module-twoC2P-module-module~modules-payment-chooser-payment-chooser-module~modu~c1a984dd",
		"modules-2c2p-module-twoC2P-module-module"
	],
	"./modules/payment-chooser/payment-chooser.module": [
		"./src/app/modules/payment-chooser/payment-chooser.module.ts",
		"default~modules-2c2p-module-twoC2P-module-module~modules-payment-chooser-payment-chooser-module~modu~c1a984dd"
	],
	"./modules/paypal-module/paypal-module.module": [
		"./src/app/modules/paypal-module/paypal-module.module.ts",
		"default~modules-2c2p-module-twoC2P-module-module~modules-payment-chooser-payment-chooser-module~modu~c1a984dd",
		"modules-paypal-module-paypal-module-module"
	],
	"./modules/paytm-module/paytm-module.module": [
		"./src/app/modules/paytm-module/paytm-module.module.ts",
		"modules-paytm-module-paytm-module-module"
	],
	"./modules/razorpay-module/razorpay-module.module": [
		"./src/app/modules/razorpay-module/razorpay-module.module.ts",
		"default~modules-2c2p-module-twoC2P-module-module~modules-payment-chooser-payment-chooser-module~modu~c1a984dd",
		"modules-razorpay-module-razorpay-module-module"
	],
	"./modules/stripe-module/stripe-module.module": [
		"./src/app/modules/stripe-module/stripe-module.module.ts",
		"default~modules-2c2p-module-twoC2P-module-module~modules-payment-chooser-payment-chooser-module~modu~c1a984dd",
		"modules-stripe-module-stripe-module-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;